import { rootApi } from "../../api/rootApi";

export const talbrosApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        approveTalbrosBulkRedemptions: builder.mutation({
            query: ({ token, tenant_id, body }) => {
                return {
                    method: "POST",
                    url: `/tenant/talbros/redemptions/bulk-approve`,
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + token,
                        slug: tenant_id,
                    },
                    body: body,
                };
            },
        }),
    }),
});

export const { useApproveTalbrosBulkRedemptionsMutation } = talbrosApi;
